import { render, staticRenderFns } from "./content-item.vue?vue&type=template&id=5b978b6d&scoped=true&"
import script from "./content-item.vue?vue&type=script&lang=js&"
export * from "./content-item.vue?vue&type=script&lang=js&"
import style0 from "./content-item.vue?vue&type=style&index=0&id=5b978b6d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b978b6d",
  null
  
)

export default component.exports